























































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import {
  NewQuotedDocumentEditorMixin,
} from "./mixins";
import { PatientFindDialogController } from "../../patient/dialogs";
import NewDocumentFormatSelectorDialog from "../dialogs/NewDocumentFormatSelectorDialog.vue";
import DocumentEditor from "../editor/DocumentEditor.vue";
import LoadedDocumentPreprocessor from "./LoadedDocumentPreprocessor.vue";

@Component({
  components: {
    DocumentEditor,
    PatientFindDialogController,
    NewDocumentFormatSelectorDialog,
    LoadedDocumentPreprocessor,
  },
})
export default class NewQuotedDocumentEditor extends Mixins(NewQuotedDocumentEditorMixin) {
  $refs!: {
    documentEditor: DocumentEditor
  };

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  async registerDocument(isTemporary: boolean): Promise<number> {
    return this.$refs.documentEditor.registerDocument(isTemporary);
  }

  async cancelEditing(): Promise<void> {
    this.$logger.debug("文書編集中止要求");
    await this.$refs.documentEditor.deleteWriteToken();
  }

  @Watch("shouldSelectFormat")
  async onShouldSelectFormatUpdated(newValue: boolean, oldValue: boolean) {
    if (!oldValue && newValue) {
      await this.validateDocumentForQuotation();
    }
  }
}
